const pagination = {
  en: {
    previous: "Previous",
    next: "Next",
    showing: "Showing",
    of: "of",
    results: "result(s)",
    to: "to"
  },
  pt: {
    previous: "Anterior",
    next: "Próximo",
    showing: "Exibindo",
    of: "de",
    results: "resultado(s)",
    to: "até"
  },
  es: {
    previous: "Anterior",
    next: "Siguiente",
    showing: "Mostrando",
    of: "de",
    results: "resultado(s)",
    to: "a"
  }
}

export default pagination
